export default __webpack_public_path__ + "static/media/ELAN L&T_B.f31ec2d4.png";